import React, { useState, useRef, useEffect } from 'react';
import { Container, Button, Box, Typography, Alert } from '@mui/material';

const CameraTest = () => {
  const [cameraStream, setCameraStream] = useState(null);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('未啟動');
  const videoRef = useRef(null);

  const startCamera = async () => {
    try {
      setError(null);
      setStatus('正在啟動相機...');
      
      console.log('開始相機測試...');
      
      // 檢查瀏覽器支援
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error('瀏覽器不支援相機');
      }

      console.log('請求相機權限...');
      
      // 使用最簡單的相機設定
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: false
      });

      console.log('相機啟動成功');
      setCameraStream(stream);
      setStatus('相機已啟動');
      
    } catch (err) {
      console.error('相機啟動失敗:', err);
      setError(`相機啟動失敗: ${err.name} - ${err.message}`);
      setStatus('啟動失敗');
    }
  };

  const stopCamera = () => {
    if (cameraStream) {
      cameraStream.getTracks().forEach(track => track.stop());
      setCameraStream(null);
      setStatus('已停止');
    }
  };

  useEffect(() => {
    if (cameraStream && videoRef.current) {
      videoRef.current.srcObject = cameraStream;
    }
  }, [cameraStream]);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        相機測試頁面
      </Typography>
      
      <Typography variant="h6" color="primary" mb={2}>
        狀態: {status}
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Box mb={3}>
        <Button 
          variant="contained" 
          onClick={startCamera} 
          sx={{ mr: 2 }}
          disabled={cameraStream}
        >
          啟動相機
        </Button>
        <Button 
          variant="outlined" 
          onClick={stopCamera}
          disabled={!cameraStream}
        >
          停止相機
        </Button>
      </Box>

      <Box textAlign="center">
        {cameraStream ? (
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            style={{
              width: '100%',
              maxWidth: '400px',
              height: 'auto',
              border: '2px solid #4caf50',
              borderRadius: '8px'
            }}
          />
        ) : (
          <Box
            sx={{
              width: '100%',
              maxWidth: '400px',
              height: '300px',
              border: '2px dashed #ccc',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#666',
              fontSize: '18px'
            }}
          >
            相機預覽區域
          </Box>
        )}
      </Box>

      <Typography variant="body2" color="textSecondary" mt={3}>
        如果相機無法啟動，請檢查：
        <br />1. 瀏覽器是否允許相機權限
        <br />2. 相機是否被其他程式使用
        <br />3. 是否使用 HTTPS 連接
      </Typography>
    </Container>
  );
};

export default CameraTest;